import {type CompanyRegistrationFormData} from '@openapi/company-registration-form';
import {type FormSchema} from '../form';

export const convertToCompanyRegistrationFormData = (
  values: FormSchema,
): CompanyRegistrationFormData => {
  return {
    ...values,
    companyInfo: {
      ...values.companyInfo,
      foundationYear: convertToNumberOrNull(values.companyInfo.foundationYear),
      foundationMonth: convertToNumberOrNull(
        values.companyInfo.foundationMonth,
      ),
      capital: convertToNumberOrNull(values.companyInfo.capital),
      employees: convertToNumberOrNull(values.companyInfo.employees),
      ipoKbn: Number(values.companyInfo.ipoKbn),
      industryKbnId: Number(values.companyInfo.industryKbnId),
      businessCategoryLv2Ids: values.companyInfo.businessCategoryLv2Ids.flatMap(
        (v) => (v === '' ? [] : Number(v)),
      ),
    },
    contactPersonInfo: {
      ...values.contactPersonInfo,
    },
  };
};

function convertToNumberOrNull(value: string | number): number | null {
  if (typeof value === 'number') {
    return value;
  }

  const trimedValue = value.trim();
  return trimedValue === '' ? null : Number(trimedValue);
}
